module.exports = __webpack_public_path__ + "static/media/group-4.7f4c88e2.svg";